import React from "react";

const Bash_Wget = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Wget</h2>
      <p>Non-interactive network downloader.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>wget [options] URL</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>wget https://example.com/file.zip
wget -c url  # resume</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Good for large downloads and resuming.</p>
    </div>
  );
};

export default Bash_Wget;
